<template>
    <div>
        <Modal v-model="isShowModal" :title="title" @on-cancel="hide()" :mask-closable="false" width="950">

            <Divider orientation="left">订单信息</Divider>
            <Row :gutter="16">
                <Col span="8">
                    <div>订单编号：{{ orderInfo.recoveryOrder.orderCode }}</div>
                </Col>
                <Col span="8">
                    <div>订单标题：{{ orderInfo.recoveryOrder.orderTitle }}</div>
                </Col>
                <Col span="8">
<!--                  <div>-->
<!--                    是否扣杂：-->
<!--                    <template v-if="orderInfo.recoveryOrder.isDeduct == 0">否</template>-->
<!--                    <template v-if="orderInfo.recoveryOrder.isDeduct == 1">是</template>-->
<!--                  </div>-->
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="8">
                    <div>下单昵称：{{ orderInfo.recoveryOrder.nickName }}</div>
                </Col>
                <Col span="8">
                    <div>订单总额：￥{{ orderInfo.recoveryOrder.totalAmount ? orderInfo.recoveryOrder.totalAmount : '-' }}
                      <span v-if="orderInfo.recoveryOrder.totalWeight && orderInfo.recoveryOrder.totalWeight < 10" class="weightColor">(未满足十公斤价格降低50%)</span>
                    </div>
                </Col>
                <Col span="8">
                    <div>赠送积分：{{ orderInfo.recoveryOrder.integral ? orderInfo.recoveryOrder.integral : 0 }}</div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="8">
                    <div>
                        订单类型：
                        <template v-if="orderInfo.recoveryOrder.orderType == 1">线上订单</template>
                        <template v-if="orderInfo.recoveryOrder.orderType == 2">线下订单</template>
                    </div>
                </Col>
                <Col span="8">
                    <div>支付类型：
                      <template v-if="orderInfo.recoveryOrder.payType == 1">线上支付</template>
                      <template v-if="orderInfo.recoveryOrder.payType == 2">线下支付</template>
                      <template v-if="orderInfo.recoveryOrder.payType == 3">积分支付</template>
                    </div>
                </Col>
              <Col span="8">
                <div>
                  订单状态：
                  <template v-if="orderInfo.recoveryOrder.orderState == 1">未接单</template>
                  <template v-if="orderInfo.recoveryOrder.orderState == 2">已接单</template>
                  <template v-if="orderInfo.recoveryOrder.orderState == 3">已完成</template>
                  <template v-if="orderInfo.recoveryOrder.orderState == 4">已取消</template>
                </div>
              </Col>
            </Row>
            <Row :gutter="16">
                <Col span="8">
                    <div>
                        异常状态：
                        <template v-if="orderInfo.recoveryOrder.isAbnormal == 0">正常</template>
                        <template v-if="orderInfo.recoveryOrder.isAbnormal == 1">异常订单</template>
                    </div>
                </Col>
                <Col span="8">
                  <div>创建时间：{{ orderInfo.recoveryOrder.createTime }}</div>
                </Col>
                <Col span="8">
                    <div>
                        异常原因：
                        <template v-if="orderInfo.recoveryOrder.abnormalCauses">
                          {{orderInfo.recoveryOrder.abnormalCauses}} {{orderInfo.recoveryUser ? ' - ' + orderInfo.recoveryUser.realName : ''}}
                        </template>
                        <template v-else>-</template>
                    </div>
                </Col>
            </Row>
            <Row :gutter="16">
              <Col span="8">
                <div v-if="orderInfo.recoveryOrder.totalWeight">
                  总重量：<span :class="[orderInfo.recoveryOrder.totalWeight < 10 ? 'weightColor' : '']">{{orderInfo.recoveryOrder.totalWeight}} 公斤</span>
                </div>
              </Col>
            </Row>
            <Divider orientation="left">回收员信息</Divider>
            <Row :gutter="16">
                <Col span="8">
                    <div>
                        回收员姓名：{{
                            orderInfo.recoveryOrder.recoveryUserName ? orderInfo.recoveryOrder.recoveryUserName : '-'
                        }}
                    </div>
                </Col>
                <Col span="8">
                    <div>
                        回收员电话：{{
                            orderInfo.recoveryOrder.recoveryUserPhone ? orderInfo.recoveryOrder.recoveryUserPhone : '-'
                        }}
                    </div>
                </Col>
                <Col span="8">
                  <div>
                    订单备注：{{
                      orderInfo.recoveryOrder.recyclerRemark ? orderInfo.recoveryOrder.recyclerRemark + ' --- ' + orderInfo.recoveryOrder.recyclerRemarkName : '-'
                    }}
                  </div>
                </Col>
            </Row>
          <Row :gutter="16">
            <Col span="8">
              <div>
                回收员评分：<Rate v-model="revoveryUserEvaluate.score" disabled/>
              </div>
            </Col>
            <Col span="8">
              <div>
                回收员评价：{{ revoveryUserEvaluate.content }}
              </div>
            </Col>
          </Row>

            <template v-if="orderInfo.orderPay">
              <Divider orientation="left">订单支付信息</Divider>
              <Row :gutter="16">
                <Col span="8">
                  <div>
                    微信付款单号：{{orderInfo.orderPay ? orderInfo.orderPay.paymentNo : ''}}
                  </div>
                </Col>
                <Col span="8">
                  <div>
                    支付金额：{{orderInfo.orderPay ? orderInfo.orderPay.totalAmount : ''}}
                  </div>
                </Col>
                <Col span="8">
                  <div>
                    付款成功时间：{{orderInfo.orderPay ? orderInfo.orderPay.paymentTime : ''}}
                  </div>
                </Col>
              </Row>
            </template>
            <Divider orientation="left">回收地址信息</Divider>
            <template>
                <Row :gutter="16">
                    <Col span="8" v-if="orderInfo.recoveryOrder.orderType == 1">
                        <div >用户姓名：{{ orderInfo.address.realName }}</div>
                    </Col>
                    <Col span="8" v-if="orderInfo.recoveryOrder.orderType == 2">
                      <div>用户名称：{{ orderInfo.recoveryOrder.nickName ? orderInfo.recoveryOrder.nickName : '-' }}</div>
                    </Col>
                    <Col span="8">
                        <div>用户手机号：{{ orderInfo.address && orderInfo.address.mobile ? orderInfo.address.mobile : '-' }}</div>
                    </Col>

                </Row>
              <Row>
                <Col span="24">
                  <div>用户地址：<span style="color: #2baee9;cursor:pointer" @click="showOrderInfoMap">{{ orderInfo.address && orderInfo.address.locationAddress }} {{ orderInfo.address && orderInfo.address.address }}</span></div>
                </Col>
              </Row>
              <Row :gutter="16" v-if="orderInfo.recoveryOrder.orderType == 1">
                <Col span="8">
                  <div>完成订单数：{{ orderInfo.completeNum }}</div>
                </Col>
                <Col span="8">
                  <div>小于10KG订单数：{{ orderInfo.below10KGNum }}</div>
                </Col>
              </Row>
              <Row :gutter="16" v-if="orderInfo.recoveryOrder.orderType == 1">
                <Col span="8">
                  <div>用户评分：<Rate v-model="userEvaluate.score" disabled/></div>
                </Col>
                <Col span="8">
                  <div>评价内容：{{ userEvaluate.content }}</div>
                </Col>
              </Row>
            </template>
<!--            <template v-else>-->
<!--                <Row :gutter="16">-->
<!--                    <Col span="8">-->
<!--                        <div>用户名称：{{ orderInfo.recoveryOrder.nickName ? orderInfo.recoveryOrder.nickName : '-' }}</div>-->
<!--                    </Col>-->
<!--                </Row>-->
<!--            </template>-->

            <Divider orientation="left">回收类别信息</Divider>
            <Row v-for="(item,index) in orderInfo.recoveryOrderItem" :key="index">
                <Col span="9" style="margin-top: 10px">
                    <div class="j-order-image">
                        <div class="j-order-image-main">
                            <img :src="item.categoryImage">
                        </div>
                        <div class="j-order-image-info">
                            <div class="j-order-goods-title">
                                {{ item.categoryName }}
                                <template v-if="item.lowerCategoryName">
                                    - {{ item.lowerCategoryName }}
                                </template>
                            </div>
                            <div class="j-order-goods-price">回收单价：{{ item.unitPrice }}元</div>
                          <div class="j-order-goods-price">回收重量：{{ item.weight }} {{ item.categoryName === '数量种类' ? '个' : '公斤'}}</div>
                        </div>
                    </div>
                </Col>
                <Col span="15">
                    <div class="j-order-image" style="margin-top: 5px">
                        <div class="j-order-image-main" style="margin-right: 10px"
                             v-for="(v,i) in formatImage(item.orderImage)" :key="i"
                             @click="previewImage(formatImage(item.orderImage))">
                            <img :src="v">
                        </div>
                    </div>
                </Col>
            </Row>

          <!-- 图片预览弹窗 -->
            <viewer :images="images" class="viewer" ref="viewer" @inited="inited" v-show="showImage">
                <template scope="scope">
                    <img v-for="src in scope.images" :src="src+`?${Date.now}`" :key="src">
                    {{ scope.options }}
                </template>
            </viewer>
<!--          <viewer :images="images" class="viewer" ref="viewer" @inited="inited" v-show="showImage">-->
<!--            <template scope="scope">-->
<!--              <img :src="images"/>-->
<!--              {{ scope.options }}-->
<!--            </template>-->
<!--          </viewer>-->

            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
                <Button type="primary" @click="hide()" :loading="loadingBtn">
                    <span v-if="!loadingBtn">确定</span>
                    <span v-else>请稍候...</span>
                </Button>
            </div>
        </Modal>
      <order-info-map ref="orderInfoMap"></order-info-map>
    </div>
</template>

<script>
import orderInfoMap from './order-info-map';
export default {
    data() {
        return {
            isShowModal: false,
            loadingBtn: false,
            orderInfo: {
                recoveryOrder: {},
                address: {},
                recoveryOrderItem: []
            },
            title: '订单详情',
            images: [],
            showImage: false,
            userEvaluate: {},
            revoveryUserEvaluate: {}
        }
    },
    methods: {
        // 显示模态框
        show(row) {
            this.isShowModal = true;
            this.getInfo(row);
        },
        // 查询订单详情
        getInfo(row) {
            this.$Spin.show();
            this.axios.post('/recoveryOrder/getInfo', {
                recoveryOrderId: row.recoveryOrderId
            }).then(res => {
                console.log(res);
                setTimeout(() => {
                    this.$Spin.hide();
                }, 300);
                if (res.status == 200) {
                    // this.$Message.success('操作成功.');
                    this.orderInfo = res.data;
                  if (res.data.evaluateList && res.data.evaluateList.length > 0) {
                    this.orderInfo.evaluateList.forEach(item => {
                      if (item.type === 1) {
                        this.userEvaluate = item
                      }
                      if (item.type === 2) {
                        this.revoveryUserEvaluate = item
                      }
                    })
                  }
                }
                if (res.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '查看订单详情接口报错',
                        duration: 0
                    });
                }
            })
        },
        inited(viewer) {
            this.$viewer = viewer
        },
        previewImage(images) {
            this.images = images;
            this.$viewer.show();
        },
        // 格式化图片
        formatImage(image) {
            if (image) {
                return image.split(',')
            }
        },
        // 关闭模态框
        hide() {
            this.isShowModal = false;
        },
        // 计算
        ride(e) {
          return e * 100
        },
        showOrderInfoMap() {
          this.$refs.orderInfoMap.show(this.orderInfo);
        },
    },
    components: {
      orderInfoMap
    }
}
</script>

<style scoped lang="less">
.j-order-image {
    display: flex;

    .j-order-image-main {
        width: 100px;
        height: 100px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .j-order-image-info {
        margin-left: 10px;

        .j-order-goods-title {
          font-weight: bold;
        }

        .j-order-goods-sku {
            margin-top: 5px;
        }

        .j-order-goods-price {
            margin-top: 5px;
        }

        .j-order-goods-num {
            margin-top: 5px;
        }
    }
}
.weightColor {
  color: red;
}
</style>